import { DateTime } from 'luxon';

const generateRows = (data: SrtToken[]): TableRow[] =>
  data.map((item) => {
    const payload: TableRow = {
      date: item.date ? DateTime.fromISO(item.date).toFormat('yyyy-LL-dd') : '',
      title: `${item.title ?? ''} ${item.description ? ' - ' + item.description : ''}`,
      // SR tokens are stored at full float precision — round for display only.
      srtToken: typeof item.srtToken === 'number' ? Number(item.srtToken.toFixed(2)) : ''
    };

    return payload;
  });

export default generateRows;
